export default {
  "content": "<path d=\"M465 127L241 384l-92-92m-9 93l-93-93m316-165L236 273\" class=\"ionicon-fill-none\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};